import React from 'react';

import BulletedListIcon from '@atlaskit/icon/core/list-bulleted';
import { token } from '@atlaskit/tokens';

import { RainbowBorder } from './RainbowBorder';
import type { IconProps } from './types';

export const Icon = (props: IconProps) => {
	const { shownAt } = props;

	return (
		<RainbowBorder shownAt={shownAt}>
			<BulletedListIcon label="" color={token('color.icon', '#44546F')} />
		</RainbowBorder>
	);
};
